module.exports = __webpack_public_path__ + "img/ic_referral_detail_close.fcb9f450.svg";